import { render, staticRenderFns } from "./tablec.vue?vue&type=template&id=1ccd0c26&scoped=true"
import script from "./tablec.vue?vue&type=script&lang=js"
export * from "./tablec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd0c26",
  null
  
)

export default component.exports